module.exports = __webpack_public_path__ + "static/img/20013 (4).a63f59d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (4).webp
// module id = dcfU
// module chunks = 14